export default __webpack_public_path__ + "static/media/mobile_mock.45695407.png";